import type { FaireProductEntity } from "../../entity_types/product";

export const p_dbkvx5i14c: FaireProductEntity = {
  token: "p_dbkvx5i14c",
  type: "product",
  name: "Balsam & Cedar \u2013 34oz Winter Holiday Scented Jar Candle",
  brandName: "A Cheerful Giver",
  imageUrl:
    "https://cdn.faire.com/fastly/161b69bda8cf77e4335be190b8599a064e8cbb843b5409989566a805f42fb64d.jpeg",
  priceDollars: 14,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/01445ab68cd1e9a4c43add01029bc847f5348fd895c09179ee6120ce113642bd.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
